'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/millisecondsAgo.js
// module id = 257
// module chunks = 1